import { ref } from 'vue';

export const siteWrapper = ref(document.body);

export const siteWrapperWidth = ref(window.innerWidth);

export function initSiteWrapperResizeObserver() {
    siteWrapper.value = document.getElementById('site_wrapper') || document.body;

    let pendingUpdate = false;
    const updateCssVars = () => {
        const isSiteWrapper = siteWrapper.value.id === 'site_wrapper';
        const scrollbarWidth = isSiteWrapper
            ? siteWrapper.value.offsetWidth - siteWrapper.value.clientWidth
            : window.innerWidth - document.documentElement.clientWidth;

        const _siteWrapperWidth = isSiteWrapper
            ? siteWrapper.value.clientWidth
            : document.documentElement.clientWidth;

        document.documentElement.style.setProperty('--site-wrapper-width', `${_siteWrapperWidth}px`);
        document.documentElement.style.setProperty('--site-wrapper-scrollbar-width', `${scrollbarWidth}px`);
        siteWrapperWidth.value = _siteWrapperWidth;
        pendingUpdate = false;
    };

    // Use requestAnimationFrame for smoother updates
    const throttledUpdateCssVars = () => {
        if (!pendingUpdate) {
            pendingUpdate = true;
            window.requestAnimationFrame(updateCssVars);
        }
    };

    if (window.ResizeObserver) {
        const observer = new ResizeObserver(throttledUpdateCssVars);
        observer.observe(siteWrapper.value);
    } else {
        // Fallback: update on window resize
        window.addEventListener('resize', updateCssVars, { passive: true });
    }

    updateCssVars();
}